import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { Container } from '../../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingSummary/components/Container.js';
import { Skeleton, Stack } from '../../../../../../../primitives/index.js';
export const RatingSummaryLoadingState = () => {
  const mdUp = useBreakpointUp('md');
  return _jsxs(Container, {
    justifyContent: "center",
    direction: mdUp ? 'row' : 'column',
    spacing: mdUp ? 1 : 0.75,
    children: [_jsx(Skeleton, {
      variant: 'rect',
      width: 84.23,
      height: 78
    }), _jsxs(Stack, {
      spacing: 0.125,
      alignItems: mdUp ? 'flex-start' : 'center',
      children: [_jsx(Skeleton, {
        variant: 'text',
        width: 255,
        height: 24
      }), _jsx(Skeleton, {
        variant: 'text',
        width: 200,
        height: 20
      }), _jsx(Skeleton, {
        variant: 'text',
        width: 150
      })]
    })]
  });
};